import { FC, FunctionComponent, ReactElement, createElement } from 'react';

type Provider = {
  provider: FunctionComponent;
  props?: any;
};

type Props = {
  providers: Provider[];
  children: ReactElement;
};

const ComposeProviders: FC<Props> = ({ providers = [], children }) => {
  if (providers.length < 0) {
    return children;
  }
  return providers
    .slice()
    .reverse()
    .reduce(
      (acc: ReactElement, { provider, props = {} }: Provider) =>
        createElement(provider, props, acc),
      children
    );
};

export default ComposeProviders;
